export default {
    "en": {
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "downloads": {
            "signed_document": "Signed document",
            "medical_record": "Medical record",
            "medical_report": "Medical report",
            "medical_prescription": "Medical prescription",
            "exam_request": "Exam request",
            "medical_record_attachment": "Medical record attachment"
        },
        "form": {
            "save": "Save",
            "login": "Login",
            "register": "Register",
            "change": "Change",
            "change_password": "Change Password",
            "forgot_password": "Forgot your password?",
            "new_user_question": "Are you a new user?"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The {attribute} is invalid.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "phone": "The {attribute} field contains an invalid number.",
            "lowercase": "The {attribute} must be lowercase.",
            "username": "The {attribute} must be lowercase and may only contain letters, numbers, dots, dashes and underscores.",
            "national_identification_number": "The {attribute} is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "first_name": "First Name",
                "last_name": "Last Name",
                "national_identification_number": "Identification Code",
                "country_code": "Country",
                "postal_code": "Postal Code",
                "area": "Area",
                "city": "City",
                "address": "Address",
                "username": "Username",
                "email": "Email Address",
                "password": "Password",
                "current_password": "Current Password",
                "new_password": "New Password",
                "phone_mobile": "Mobile Phone",
                "phone_home": "Landline Phone",
                "register_country_code": "Country",
                "register_national_identification_number": "Identification Code",
                "register_username": "Username",
                "register_email": "Email Address",
                "register_password": "Password"
            }
        },
        "user": {
            "user_profile": "User Profile",
            "user_data": "User Data",
            "password_data": "Password Change",
            "bill_data": "Bill Data",
            "personal_data": "Personal Data",
            "residency": "Residency",
            "bill_data_locked": "Your billing data has already been stored in our database, to apply any change please report them to the staff during the billing phase.",
            "first_name": "First Name",
            "middle_name": "Second Name",
            "last_name": "Last Name",
            "national_identification_number": "Identification Code",
            "vat_code": "VAT Code",
            "country": "Country",
            "residential_country": "Residential Country",
            "area": "Area",
            "city": "City",
            "postal_code": "Postal Code",
            "address": "Address",
            "username": "Username",
            "email": "Email Address",
            "username_or_email": "Username or Email Address",
            "password": "Password",
            "current_password": "Current Password",
            "new_password": "New Password",
            "confirm_password": "Confirm Password",
            "phone_mobile": "Mobile Phone",
            "phone_home": "Landline Phone",
            "note": "Note",
            "card_info": "Card Informations",
            "accept_policy_agreement": "I accept the <a class='btn btn-link p-0 border-0' target='_blank' href='/terms-and-conditions'>Service Terms & Conditions</a> and I consent to the processing of my personal data as described in the <a class='btn btn-link p-0 border-0' target='_blank' href='/privacy'>Privacy Policy</a>",
            "remember_me": "Remember Me (use cookies)"
        },
        "general": {
            "service": "Service",
            "resource": "Practitioner",
            "purchase_date_time": "Purchase",
            "book_date_time": "Booking",
            "duration": "Duration",
            "price": "Price",
            "paid": "Paid Amount",
            "no_result": "No result",
            "back_to_homepage": "Back to homepage"
        },
        "error": {
            "missing_search_parameters": "Select search parameters",
            "connection_fail_during_parameter_fetching": "Connection error during search parameters fetching",
            "online_booking_disabled": "Online booking is not active. To book, please contact the facility directly.",
            "no_bookable_services": "There are currently no services available for online booking. Please try again later or contact the facility directly."
        },
        "user-sync": {
            "missing_contacts_info": "Your personal data are already present in our archives but we do not have a valid contact.\nTo verify your identity, please contact the medical center to communicate your mobile number or email.\nOnce we have recorded your contact details in our archives you will be able to access your reserved area.\n",
            "patient_not_found": "Patient not found, contact the medical center to verify if the personal data have been deleted."
        },
        "stripe-connect": {
            "title_connect": "Connect with Stripe Connect",
            "title_disconnect": "Disconnect your Stripe Connect",
            "info_connect": "You have been invited to connect your Stripe account with our platform.\nOnce connected, you can withdraw access to your account at any time from this page or on your stripe profile by going to the <b> Settings => Authorized applications </b> page..\n\nTo proceed click on the button below.",
            "info_disconnect": "From this page you can withdraw access to your Stripe account.\n\nTo proceed click on the button below.",
            "connect": "Connect Stripe account",
            "disconnect": "Disonnect Stripe account"
        },
        "booking": {
            "show_more_times": "Show More Times",
            "show_less_times": "Show Less Times",
            "service_description": "Service description",
            "preparation_notes": "Preparation notes",
            "close": "Close",
            "cancel_appointment": "Cancel",
            "cancellation": "Cancellation",
            "cancellation_contact_short": "Contact the center",
            "cancellation_unavailable": "Unavailable",
            "cancellation_past": "Past appointment",
            "cancellation_past_help": "A past appointment cannot be cancelled.",
            "cancel_appointment_help": "Cancel this appointment. You will be asked to confirm before proceeding; cancellation is final.",
            "cancelled_help": "This appointment has already been cancelled.",
            "cancellation_contact_help": "Online cancellation is unavailable for this appointment. Contact the center to request cancellation.",
            "cancellation_phone_help": "Call the center to request cancellation of the appointment.",
            "cancellation_deadline_short": "Until {date} at {time}",
            "cancel_appointment_confirm": "Do you want to cancel the appointment on {date}? This cannot be undone.",
            "cancellation_deadline": "Can be cancelled until {date}",
            "cancellation_contact_center": "To cancel, contact the center",
            "cancelled": "Cancelled",
            "cancellation_success": "The appointment has been cancelled.",
            "cancellation_not_allowed": "This appointment cannot be cancelled online.",
            "cancellation_not_allowed_contact": "This appointment can no longer be cancelled online, please contact the center.",
            "cancellation_error": "The appointment could not be cancelled, please try again later or contact the center."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "otp": {
            "info_line1": "To access this private area you need to insert a One Time Password that we sent to {sentTo}.",
            "info_line1_sent_to_mail": "to the mail address <b>{to}</b>",
            "info_line1_sent_to_sms": "to the phone number <b>{to}</b>",
            "info_line2": "Your secure session will expire after {expires} minutes of inactivity or until you log out.",
            "otp_required": "OTP Required",
            "one_time_password": "One Time Password",
            "verify": "Verify",
            "new_otp": "Need a new OTP?",
            "missing_contacts": "Missing user contact data",
            "call": "Call",
            "send_email": "Send an email"
        }
    },
    "it": {
        "Home": "Home",
        "Book Medical Service": "Prenota prestazione",
        "View Personal Documents": "Visualizza documenti personali",
        "Control Panel": "Pannello di controllo",
        "Stripe Connect": "Stripe connect",
        "Settings": "Impostazioni",
        "Profile": "Profilo",
        "Purchase History": "Storico acquisti",
        "Documents": "Documenti",
        "Appointments": "Appuntamenti",
        "Logout": "Logout",
        "New User": "Nuovo utente",
        "Existing User": "Utente esistente",
        "Reset Password": "Reset password",
        "Send password reset link": "Invia link di reset password",
        "Reset Password Notification": "Notifica di reset password",
        "Verify Email Address": "Verifica indirizzo email",
        "Please click the button below to verify your email address.": "Per favore, clicca il bottone qui sotto per verificare il tuo indirizzo email.",
        "If you did not create an account, no further action is required.": "Se non hai creato un account puoi ignorare questa email.",
        "You are receiving this email because we received a password reset request for your account.": "Se stai ricevendo questa mail è perchè hai effettuato la richiesta di reset password per il tuo account.",
        "This password reset link will expire in {count} minutes.": "Questo link di reset password scadrà tra  {count} minuti",
        "If you did not request a password reset, no further action is required.": "Se non hai effettuato una richiesta di reset password puoi ignorare questa email.",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser: [{actionURL}]({actionURL})": "Se hai problemi a cliccare il bottone \"{actionText}\", copia e incolla l'indirizzo seguente nel tuo browser: [{actionURL}]({actionURL})",
        "Verify your email address": "Verifica il tuo indirizzo email",
        "A fresh verification link has been sent to your email address.": "Un nuovo link di verifica utente è stato inviato al tuo indirizzo email.",
        "Before proceeding, please check your email {email} for a verification link.": "Prima di procedere, per favore controlla la tua email {email} per il link di verifica utente.",
        "If you did not receive the email": "Se non hai ricevuto l'email",
        "click here to request another": "clicca qui per inviarne un'altra",
        "If you entered your email wrong, you can change it here": "Se hai sbagliato ad inserire la tua email puoi cambiarla qui",
        "All rights reserved.": "Tutti i diritti riservati",
        "Action Required": "Azione Richiesta",
        "Regards": "Saluti",
        "Whoops!": "Ooops!",
        "Hello!": "Salve!",
        "Type": "Tipo",
        "Author": "Autore",
        "Filename": "Nome file",
        "Download": "Scarica",
        "pagination": {
            "previous": "&laquo; Indietro",
            "next": "Avanti &raquo;"
        },
        "downloads": {
            "signed_document": "Documento firmato",
            "medical_record": "Cartella clinica",
            "medical_report": "Referto medico",
            "medical_prescription": "Prescrizione medica",
            "exam_request": "Richiesta esame",
            "medical_record_attachment": "Allegato a cartella clinica"
        },
        "form": {
            "save": "Salva",
            "login": "Accedi",
            "register": "Registrati",
            "change": "Cambia",
            "change_password": "Cambia Password",
            "forgot_password": "Hai dimenticato la password?",
            "new_user_question": "Sei un nuovo utente?"
        },
        "passwords": {
            "reset": "La tua password è stata resettata!",
            "sent": "Ti abbiamo inviato un link via mail per resettare la password!",
            "throttled": "Please wait before retrying.",
            "token": "Il token di reset password non è valido.",
            "user": "Non esiste nessun utente con questo indirizzo e-mail."
        },
        "validation": {
            "accepted": "Il campo '{attribute}' deve essere accettato.",
            "active_url": "Il campo '{attribute}' non contiene un indirizzo email valido.",
            "after": "Il campo '{attribute}' deve essere successivo a {date}.",
            "after_or_equal": "Il campo '{attribute}' deve essere successivo o uguale a {date}.",
            "alpha": "Il campo '{attribute}' può contenere solamente lettere.",
            "alpha_dash": "Il campo '{attribute}' può contenere solamente lettere, numeri e trattini.",
            "alpha_num": "Il campo '{attribute}' può contenere solamente lettere e numeri.",
            "array": "Il campo '{attribute}' deve essere un array.",
            "before": "Il campo '{attribute}' deve essere una data antecedente a {date}.",
            "before_or_equal": "Il campo '{attribute}' deve essere una data antecedente o uguale a {date}.",
            "between": {
                "numeric": "Il campo '{attribute}' deve essere compreso tra {min} e {max}.",
                "file": "Il campo '{attribute}' deve essere compreso tra {min} e {max} kilobytes.",
                "string": "Il campo '{attribute}' deve essere compreso tra {min} and {max} caratteri.",
                "array": "Il campo '{attribute}' deve essere compreso tra {min} and {max} elementi."
            },
            "boolean": "Il campo '{attribute}' deve essere vero o falso.",
            "confirmed": "Il campo '{attribute}' non corrisponde.",
            "date": "Il campo '{attribute}' non è una data valida.",
            "date_equals": "Il campo '{attribute}' deve essere uguale a {date}.",
            "date_format": "Il campo '{attribute}' non corrisponde al formato {format}.",
            "different": "Il campo '{attribute}' e {other} devono essere diversi.",
            "digits": "Il campo '{attribute}' deve essere lungo {digits} caratteri.",
            "digits_between": "Il campo '{attribute}' deve essere compreso tra {min} e {max} caratteri.",
            "dimensions": "Le dimensioni immagine di '{attribute}' non sono valide",
            "distinct": "Il campo '{attribute}' contiene dei valori duplicati",
            "email": "Il campo '{attribute}' deve essere un indirizzo email valido.",
            "ends_with": "Il campo '{attribute}' deve terminare con uno dei seguenti valori: {values}.",
            "exists": "L'elemento '{attribute}' selezionato non è valido.",
            "file": "Il campo '{attribute}' deve essere un file.",
            "filled": "Il campo '{attribute}' deve essere valorizzato.",
            "gt": {
                "numeric": "Il campo '{attribute}' deve essere maggiore di {value}.",
                "file": "Il campo '{attribute}' deve essere più grande di {value} kilobytes.",
                "string": "Il campo '{attribute}' deve contenere più di {value} caratteri.",
                "array": "Il campo '{attribute}' deve contenere più di {value} elementi."
            },
            "gte": {
                "numeric": "Il campo '{attribute}' deve essere maggiore o uguale di {value}.",
                "file": "Il campo '{attribute}' deve essere maggiore o uguale a {value} kilobytes.",
                "string": "Il campo '{attribute}' deve contenere almeno {value} caratteri.",
                "array": "Il campo '{attribute}' deve contenere almeno {value} elementi."
            },
            "image": "Il campo '{attribute}' deve essere un'immagine.",
            "in": "Il campo '{attribute}' selezionato non è valido.",
            "in_array": "Il campo '{attribute}' non esiste in {other}.",
            "integer": "Il campo '{attribute}' deve essere un intero.",
            "ip": "Il campo '{attribute}' deve essere un indirizzo IP valido.",
            "ipv4": "Il campo '{attribute}' deve essere un indirizzo IPv4 valido.",
            "ipv6": "Il campo '{attribute}' deve essere un indirizzo IPv6 valido.",
            "json": "Il campo '{attribute}' deve contenere una stringa JSON valida.",
            "lt": {
                "numeric": "Il campo '{attribute}' deve essere inferiore a {value}.",
                "file": "Il campo '{attribute}' deve essere più piccolo di {value} kilobytes.",
                "string": "Il campo '{attribute}' deve contenere meno di {value} caratteri.",
                "array": "Il campo '{attribute}' deve contenere meno di {value} elementi."
            },
            "lte": {
                "numeric": "Il campo '{attribute}' deve essere inferiore o uguale a {value}.",
                "file": "Il campo '{attribute}' deve essere minore o uguale a {value} kilobytes.",
                "string": "Il campo '{attribute}' deve contenere non più di {value} caratteri.",
                "array": "Il campo '{attribute}' deve contenere non più di {value} elementi."
            },
            "max": {
                "numeric": "Il campo '{attribute}' non può essere superiore a {max}.",
                "file": "Il campo '{attribute}' non può essere più grande di {max} kilobytes.",
                "string": "Il campo '{attribute}' non può essere più lungo di {max} caratteri.",
                "array": "Il campo '{attribute}' non può contenere più di {max} elementi."
            },
            "mimes": "Il campo '{attribute}' deve contenere un file di tipo: {values}.",
            "mimetypes": "Il campo '{attribute}' deve contenere un file di tipo: {values}.",
            "min": {
                "numeric": "Il campo '{attribute}' deve essere almeno {min}.",
                "file": "Il campo '{attribute}' deve essere almeno {min} kilobyte.",
                "string": "Il campo '{attribute}' deve avere almeno {min} caratteri.",
                "array": "Il campo '{attribute}' deve avere almeno {min} elementi."
            },
            "not_in": "Il campo '{attribute}' selezionato non è valido.",
            "not_regex": "Il formato di '{attribute}' non è valido.",
            "numeric": "Il campo '{attribute}' deve essere un numero.",
            "password": "Il campo '{attribute}' non è valido.",
            "present": "Il campo '{attribute}' deve essere presente.",
            "regex": "Il formato di '{attribute}' non è valido.",
            "required": "Il campo '{attribute}' è richiesto.",
            "required_if": "Il campo '{attribute}' è richiesto quando {other} è {value}.",
            "required_unless": "Il campo '{attribute}' è richiesto salvo che {other} sia in {values}.",
            "required_with": "Il campo '{attribute}' è richiesto quando {values} è presente.",
            "required_with_all": "Il campo '{attribute}' è richiesto quando sono presenti {values}.",
            "required_without": "Il campo '{attribute}' è richiesto quando {values} non è presente.",
            "required_without_all": "Il campo '{attribute}' è richiesto quanto nessuno di {values} è presente.",
            "same": "Il campo '{attribute}' e {other} devono corrispondere.",
            "size": {
                "numeric": "Il campo '{attribute}' deve essere {size}.",
                "file": "Il campo '{attribute}' deve essere {size} kilobytes.",
                "string": "Il campo '{attribute}' deve essere di {size} caratteri.",
                "array": "Il campo '{attribute}' deve contenere {size} elementi."
            },
            "starts_with": "Il campo '{attribute}' deve cominciare con uno dei seguenti valori: {values}.",
            "string": "Il campo '{attribute}' deve essere una stringa.",
            "timezone": "Il campo '{attribute}' deve essere una zona valida.",
            "unique": "Il campo '{attribute}' è già in uso.",
            "uploaded": "L'upload di '{attribute}' è fallito",
            "url": "Il formato di '{attribute}' non è valido.",
            "uuid": "Il campo '{attribute}' deve essere un UUID valido.",
            "phone": "Il campo '{attribute}' deve essere un numero di telefono valido.",
            "lowercase": "Il campo {attribute} deve contenere solo caratteri minuscoli.",
            "username": "Il campo {attribute} deve essere minuscolo e può contenere solo lettere, numeri, punti e trattini.",
            "national_identification_number": "Il campo '{attribute}' non è valido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "first_name": "Nome",
                "last_name": "Cognome",
                "national_identification_number": "Codice Fiscale",
                "country_code": "Stato",
                "postal_code": "CAP",
                "area": "Provincia",
                "city": "Comune",
                "address": "Indirizzo",
                "username": "Username",
                "email": "Indirizzo Email",
                "password": "Password",
                "current_password": "Password Corrente",
                "new_password": "Nuova Password",
                "phone_mobile": "Cellulare",
                "phone_home": "Telefono Fisso",
                "register_country_code": "Stato",
                "register_national_identification_number": "Codice Fiscale",
                "register_username": "Username",
                "register_email": "Indirizzo Email",
                "register_password": "Password"
            }
        },
        "user": {
            "user_profile": "Profilo Utente",
            "user_data": "Dati Utente",
            "password_data": "Cambio Password",
            "bill_data": "Dati Fatturazione",
            "personal_data": "Dati Anagrafici",
            "residency": "Residenza",
            "bill_data_locked": "I tuoi dati di fatturazione sono già stati archiviati nel nostro database, eventuali modifiche andranno segnalate al personale in fase di fatturazione.",
            "first_name": "Nome",
            "middle_name": "Secondo Nome",
            "last_name": "Cognome",
            "national_identification_number": "Codice Fiscale",
            "vat_code": "Partita IVA",
            "country": "Stato",
            "residential_country": "Stato di Residenza",
            "area": "Provincia",
            "city": "Comune",
            "postal_code": "CAP",
            "address": "Indirizzo",
            "username": "Username",
            "email": "Indirizzo Email",
            "username_or_email": "Username o Indirizzo Email",
            "password": "Password",
            "current_password": "Password Corrente",
            "new_password": "Nuova Password",
            "confirm_password": "Conferma Password",
            "phone_mobile": "Cellulare",
            "phone_home": "Telefono Fisso",
            "note": "Note",
            "card_info": "Informazioni sulla Carta",
            "accept_policy_agreement": "Accetto <a class='btn btn-link p-0 border-0' target='_blank' href='/terms-and-conditions'>Termini e Condizioni del Servizio</a> e acconsento al trattamento dei miei dati personali come descritto nell'<a class='btn btn-link p-0 border-0' target='_blank' href='/privacy'>Informativa sulla Privacy</a>",
            "remember_me": "Ricorda dati di accesso (usa i cookie)"
        },
        "general": {
            "service": "Prestazione",
            "resource": "Professionista",
            "purchase_date_time": "Acquisto",
            "book_date_time": "Prenotazione",
            "duration": "Durata",
            "price": "Prezzo",
            "paid": "Pagato",
            "no_result": "Nessun risultato",
            "back_to_homepage": "Torna all'homepage"
        },
        "error": {
            "missing_search_parameters": "Selezionare i parametri di ricerca",
            "connection_fail_during_parameter_fetching": "Errore di connessione durante la lettura dei parametri di ricerca",
            "online_booking_disabled": "La prenotazione online non è attiva. Per prenotare contatta direttamente la struttura.",
            "no_bookable_services": "Al momento non ci sono prestazioni prenotabili online. Riprova più tardi o contatta direttamente la struttura."
        },
        "user-sync": {
            "missing_contacts_info": "I tuoi dati anagrafici risultano già presenti nei nostri archivi ma non siamo in possesso di un tuo contatto valido.\nPer verificare la tua identità ti preghiamo di contattare il centro medico per comunicare il tuo numero di cellulare o la tua email.\nUna volta che avremo registrato i tuoi dati di contatto nei nostri archivi potrai accedere alla tua area riservata.\n",
            "patient_not_found": "Paziente non trovato, contattare il centro per verificare se i dati anagrafici sono stati cancellati."
        },
        "stripe-connect": {
            "title_connect": "Connessione con Stripe Connect",
            "title_disconnect": "Disconnessione da Stripe Connect",
            "info_connect": "Sei stato invitato a connettere il tuo account Stripe con la piattaforma Portale Pazienti MM.\nUna volta collegato, potrai revocare l'accesso al tuo account in qualsiasi momento da questa pagina o sul tuo profilo stripe andando alla pagina <b>Impostazioni => Applicazioni autorizzate</b>.\n\nPer procedere clicca sul bottone qui sotto.",
            "info_disconnect": "Da questa pagina puoi revocare l'accesso al tuo account Stripe.\n\nPer procedere clicca sul bottone qui sotto.",
            "connect": "Connetti account Stripe",
            "disconnect": "Disconnetti account Stripe"
        },
        "booking": {
            "show_more_times": "Mostra Altri Orari",
            "show_less_times": "Mostra Meno Orari",
            "service_description": "Descrizione prestazione",
            "preparation_notes": "Note di preparazione",
            "close": "Chiudi",
            "cancel_appointment": "Annulla",
            "cancellation": "Annullamento",
            "cancellation_contact_short": "Contatta il centro",
            "cancellation_unavailable": "Non disponibile",
            "cancellation_past": "Appuntamento passato",
            "cancellation_past_help": "Non è possibile annullare un appuntamento passato.",
            "cancel_appointment_help": "Annulla questo appuntamento. Ti verrà chiesta conferma prima di procedere; l'operazione è definitiva.",
            "cancelled_help": "Questo appuntamento è già stato annullato.",
            "cancellation_contact_help": "L'annullamento online non è disponibile per questo appuntamento. Per richiederlo, contatta il centro.",
            "cancellation_phone_help": "Chiama il centro per richiedere l'annullamento dell'appuntamento.",
            "cancellation_deadline_short": "Entro {date}, {time}",
            "cancel_appointment_confirm": "Vuoi annullare l'appuntamento del {date}? L'operazione non si può annullare.",
            "cancellation_deadline": "Annullabile fino al {date}",
            "cancellation_contact_center": "Per annullare contatta il centro",
            "cancelled": "Annullato",
            "cancellation_success": "L'appuntamento è stato annullato.",
            "cancellation_not_allowed": "Questo appuntamento non può essere annullato online.",
            "cancellation_not_allowed_contact": "Questo appuntamento non può più essere annullato online, contatta il centro.",
            "cancellation_error": "Non è stato possibile annullare l'appuntamento, riprova più tardi o contatta il centro."
        },
        "auth": {
            "failed": "Credenziali non valide.",
            "throttle": "Hai effettuato troppi tentativi di. Si prega di riprovare in {seconds} secondi."
        },
        "otp": {
            "info_line1": "Per accedere a quest'area privata devi inserire il codice OTP che ti abbiamo inviato {sentTo}.",
            "info_line1_sent_to_mail": "all'indirizzo <b>{to}</b>",
            "info_line1_sent_to_sms": "al numero <b>{to}</b>",
            "info_line2": "La tua sessione sicura scadrà automaticamente dopo {expires} minuti di inattività o finchè non effettui il logout.",
            "otp_required": "OTP Richiesto",
            "one_time_password": "Codice OTP",
            "verify": "Verifica",
            "new_otp": "Hai bisogno di un nuovo codice OTP?",
            "missing_contacts": "Informazioni di contatto mancanti",
            "call": "Chiama",
            "send_email": "Invia una email"
        }
    }
}
